import testUser from '../../mocks/testUser';
import {
  allAnticipationReports,
  anticipationReport,
  bingeReport,
  monitoringReport,
  reportBuilder,
  anticipationMovies,
  dateLookupAnticipation
} from '../../config/filters';

const reportsConfig = {
  testUser,
  ANTICIPATION_REPORT_FILTERS: anticipationReport,
  ANTICIPATION_REPORT_PAGE_ID: 'anticipationReport',
  BINGE_REPORT_FILTERS: bingeReport,
  BINGE_REPORT_PAGE_ID: 'bingeReport',
  MONITORING_REPORT_FILTERS: monitoringReport,
  MONITORING_REPORT_PAGE_ID: 'monitoringReport',
  REPORT_BUILDER_REPORT_FILTERS: reportBuilder,
  REPORT_BUILDER_REPORT_PAGE_ID: 'reportBuilder',
  ANTICIPATION_MOVIE_REPORT_PAGE_ID: 'anticipationMovies',
  ANTICIPATION_MOVIE_REPORT_FILTERS: anticipationMovies,
  ALL_ANTICIPATION_REPORT_FILTERS: allAnticipationReports,
  ALL_ANTICIPATION_REPORT_PAGE_ID: 'allAnticipationReports',
  DATE_LOOKUP_ANTICIPATION: dateLookupAnticipation
};

export default reportsConfig;
